// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import EditOrderItems from '../components/EditOrderItems';
import {actions as ManualOrderActions} from '../../manual-order/duck';

import type {RootState} from '../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    products: state.manualOrder.products,
    isFetchingProducts: state.manualOrder.isFetchingProducts,
    pagination: state.manualOrder.pagination,
    currency: state.currency.currency,
    categories: state.categories.categories,
    itemPrices: state.manualOrder.itemPrices,
    subTotal: state.manualOrder.subTotal,
    editOrderSuccess: state.manualOrder.editOrderSuccess,
    editOrderError: state.manualOrder.editOrderError,
    isEditingOrder: state.manualOrder.isEditingOrder,
    couponDiscount: state.manualOrder.couponDiscount,
    order: state.order.order,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ManualOrderActions,
      },
      dispatch
    )
)(EditOrderItems);
